var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.staff)?_c('span',{staticClass:"staff_name",class:_vm.staff.state === 1 ? 'quit_staff' : ''},[_vm._v(" "+_vm._s(_vm.staff.name || '-')+" ")]):_c('span',[_vm._v("-")])
}
var staticRenderFns = []

export { render, staticRenderFns }